// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"RVPriceModal_modalContainer__saOl/","bodyContainer":"RVPriceModal_bodyContainer__gpJIA","rvModalCell":"RVPriceModal_rvModalCell__YJr3d"};